document.addEventListener('click', async (e) => {
    const btn = e.target.closest('#amazon-checkout');
    if (!btn) return;

    e.preventDefault();

    const cfg = JSON.parse(document.getElementById('amazon-config').textContent);
    const ISO = cfg.iso;
    const TAG = cfg.associateTags[ISO];
    const KEY = cfg.awsAccessKeyId;
    const enableFallbackCheckoutLink = cfg.enableFallbackCheckoutLink;
    const fallbackCheckoutLink = cfg.fallbackCheckoutLink[ISO];
    if (!TAG) return;

    const cart = await fetch('/cart.js').then(r => r.json());

    const params = new URLSearchParams({ AssociateTag: TAG });
    if (KEY) params.set('AWSAccessKeyId', KEY);
    let i = 1;

    cart.items.forEach(item => {
        const asin = item.properties?._asin || '';
        if (!asin) return;

        params.set(`ASIN.${i}`, asin);
        params.set(`Quantity.${i}`, item.quantity);
        i++;
    });

    if (i === 1) {
        if (enableFallbackCheckoutLink && fallbackCheckoutLink !== '') {
            window.location.href = fallbackCheckoutLink;
        }
        return;
    }

    const domainMap = { US: 'www.amazon.com', CA: 'www.amazon.ca', GB: 'www.amazon.co.uk' };
    const domain = domainMap[ISO];
    if (!domain) return;

    window.location.href = `https://${domain}/gp/aws/cart/add.html?${params.toString()}`;
});